import { isMongoObjectId } from '@terra/shared-utils';

type LinkedChatObject = {
  kind: string;
  id: string;
  label?: string;
};

export function resolveFindingOpenFromChat({
  targetId,
  linkedObject,
  preferEditMode = false,
}: {
  targetId: string;
  targetLabel?: string;
  linkedObject?: LinkedChatObject;
  preferEditMode?: boolean;
}): { findingId: string; mode: 'view' | 'edit' } {
  const mode = preferEditMode ? 'edit' : 'view';
  const targetIdValid = isMongoObjectId(targetId);

  if (targetIdValid) {
    return {
      findingId: targetId,
      mode,
    };
  }

  const linkedIsFinding = linkedObject?.kind === 'Finding';
  const linkedIdValid =
    linkedIsFinding && isMongoObjectId(linkedObject.id ?? '');

  if (linkedIdValid) {
    return {
      findingId: linkedObject.id,
      mode,
    };
  }

  return {
    findingId: targetId,
    mode,
  };
}
